<script setup lang="ts">

import { VNodeRenderer } from '@layouts/components/VNodeRenderer'
import { userAbilityRulesStorage } from '@layouts/plugins/casl'
import { themeConfig } from '@themeConfig'

import liff from "@line/liff";

definePage({
  meta: {
    layout: 'blank',
    unauthenticatedOnly: true,
  },
})

const route = useRoute('login-linebot')
const router = useRouter()

onMounted(async () => {
  $api('/linebot/liffId', {
    method: 'GET',
    onResponseError({ response }) {
      console.error('error.', response)
    }
  }).then((data)=>{
    liffID.value = data["login"]
    liff.init({
      liffId : liffID.value
    }).then(function(){
      //if(liff.isInClient() && !liff.isLoggedIn()) liff.login()
      if(!liff.isLoggedIn()) liff.login()
      liff.getProfile().then(profile => {
          if (!profile.userId) {
          location.href = '/'
          return
        }
        login(profile.userId)
      })
    })
  })
})

const errorMsg = ref('')
const ability = useAbility()
const liffID = ref("")


const login = async (oauthId) => {
  try {
    // 登入前先清空舊的本機儲存空間，避免舊資料干擾
    localStorage.clear()

    const res = await $api('/linebot/login/'+oauthId, {
      method: 'GET',
      onResponseError({ response }) {
        errorMsg.value = response._data.message
      },
    })
    const { data } = res
    console.debug('login res data: ', data)
    //
    // 使用共享的 ref，確保與 isHidden 函數同步
    userAbilityRulesStorage.value = data.userAbilityRules
    ability.update(data.userAbilityRules)
    //
    useStorage('userData', {}).value = data.userInfo
    useStorage('roles', []).value = data.userInfo.roles
    useStorage('userName', '').value = data.userInfo.name
    useCookie('userToken').value = data.userInfo.token
    useStorage('depNo', '').value = data.userInfo.depNo
    useStorage('orgType', '').value = data.userInfo.orgType

    await nextTick(() => {
      const targetPath = route.query.to ? String(route.query.to) : '/'
      const resolvedRoute = router.resolve(targetPath)
      window.location.href = resolvedRoute.href
    })
  }
  catch (err) {
    console.error(err)
    $swal({
        position: 'top-end',
        icon: 'error',
        title: '登入失敗',
        showConfirmButton: false,
        timer: 1500,
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
    }).then(() => {
        router.replace(route.query.to ? String(route.query.to) : '/')
    })
    
  }
}


</script>

    <style>
        body {
            margin: 0;
            padding: 0;
            font-family: sans-serif;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            height: 100vh;
            background: #f5f5f5;
        }

        .loader {
            border: 6px solid #eee;
            border-top: 6px solid #3498db;
            border-radius: 50%;
            width: 50px;
            height: 50px;
            animation: spin 1s linear infinite;
            margin-bottom: 20px;
        }

        @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
        }

        .text {
            font-size: 18px;
            color: #555;
        }
    </style>


<template>
  <body>
    <div class="loader"></div>
    <div class="text">登入中，請稍候...</div>
  </body>
</template>

<style lang="scss">

</style>
